import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { resolveCoverUrl } from '../../services/api';
import BookCard from '../../components/BookCard';
import styles from './CategoryBooks.module.css';

const LIST_CONFIG = {
  latest: { title: '最近更新', apiPath: '/novels/latest' },
  recommended: { title: '精选推荐', apiPath: '/novels/recommended' },
};

const MAX_LIMIT = 200;

const DiscoverListPage = ({ listType }) => {
  const navigate = useNavigate();
  const config = LIST_CONFIG[listType];
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!config) {
      setError('无效的列表类型');
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchList = async () => {
      try {
        setLoading(true);
        setError('');
        const { data } = await api.get(config.apiPath, {
          params: { limit: MAX_LIMIT, skip: 0 },
        });

        if (cancelled) return;

        const list = Array.isArray(data) ? data : [];
        const normalized = list.map((novel) => ({
          id: novel.id,
          title: novel.title,
          author: novel.author,
          description: novel.description,
          cover_image_url: resolveCoverUrl(novel.cover_image_url || novel.cover_img_url),
          category: Array.isArray(novel.categories) && novel.categories[0]?.name,
          is_completed: novel.is_completed ?? false,
        }));

        setBooks(normalized);
      } catch (err) {
        console.error('获取列表失败:', err);
        if (!cancelled) {
          setError('加载失败，请稍后重试');
          setBooks([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchList();
    return () => { cancelled = true; };
  }, [listType, config]);

  const handleBack = () => navigate('/');

  if (!config) {
    return (
      <div className={styles.categoryPage}>
        <div className={styles.header}>
          <button type="button" className={styles.backBtn} onClick={() => navigate('/')} aria-label="返回">
            <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
          </button>
          <p className={styles.statusMessage}>无效的列表类型</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.categoryPage}>
      <div className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={handleBack}
          aria-label="返回主页"
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <div className={styles.headerInfo}>
          <h1 className={styles.title}>{config.title}</h1>
          {!loading && !error && (
            <span className={styles.count}>共 {books.length} 本小说</span>
          )}
        </div>
      </div>
      <div className={styles.content}>
        {loading && (
          <div className={styles.statusMessage}>加载中...</div>
        )}
        {!loading && error && (
          <div className={`${styles.statusMessage} ${styles.errorText}`}>{error}</div>
        )}
        {!loading && !error && books.length === 0 && (
          <div className={styles.statusMessage}>暂无作品</div>
        )}
        {!loading && !error && books.length > 0 && (
          <div className={styles.scrollArea}>
            <div className={styles.booksGrid}>
              {books.map((book) => (
                <BookCard
                  key={book.id}
                  book={book}
                  showStatus
                  from={`/discover/${listType}`}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DiscoverListPage;
